export const CONNECTION_SUCCESSFUL_STATUS = 'success';
export const CONNECTION_FAILED_STATUS = 'error';
export const DISCONNECTION_SUCCESSFUL_STATUS = 'disconnect-success';
export const DISCONNECTION_FAILED_STATUS = 'disconnect-error';
